const state = {
    error: null,
    products: [],
    editProduct: false,
    // Productos activos para el buscador de ventas internas, atados al
    // tenant y con TTL corto para no pedirlos en cada venta.
    saleProducts: {
        data: null,
        tenantId: null,
        expiredAt: null
    },
    // El modal de "no hay productos" se muestra una vez por sesion; despues
    // queda solo el aviso bajo el buscador.
    isNoSaleProductsNoticeShown: false
};

export default state;
